import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
  validateUrl,
} from '@Utils/validation';
import { z } from 'zod';

enum GH_STRATEGY_MESSAGE {
  INTRODUCTION_EN = 'กรุณาระบุคำอธิบายเพิ่มเติมการกำหนดกลยุทธ์และแผนการจัดการก๊าซเรือนกระจกให้เป็นไปตามเป้าหมายเป็นภาษาอังกฤษ',
  PLAN_DESCRIPTION = 'กรุณาระบุคำอธิบายรายละเอียดแผนการจัดการก๊าซเรือนกระจก',
  PLAN_DESCRIPTION_EN = 'กรุณาระบุคำอธิบายรายละเอียดแผนการจัดการก๊าซเรือนกระจกเป็นภาษาอังกฤษ',
  PLAN_REMARK_EN = 'กรุณาระบุหมายเหตุแผนการจัดการก๊าซเรือนกระจกเป็นภาษาอังกฤษ',
  PLAN_IS_URL = 'กรุณาระบุ URL ที่ถูกต้อง',
}

const GhStrategyPlanSchema = z.object({
  descriptionTh: z
    .string({ message: GH_STRATEGY_MESSAGE.PLAN_DESCRIPTION })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  descriptionEn: z
    .string({ message: GH_STRATEGY_MESSAGE.PLAN_DESCRIPTION })
    .regex(validateEditorEn, {
      message: GH_STRATEGY_MESSAGE.PLAN_DESCRIPTION_EN,
    })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, { message: GH_STRATEGY_MESSAGE.PLAN_REMARK_EN })
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  urlTh: z
    .string()
    .regex(validateUrl, { message: GH_STRATEGY_MESSAGE.PLAN_IS_URL })
    .optional()
    .or(z.literal(''))
    .nullable(),
  urlEn: z
    .string()
    .regex(validateUrl, { message: GH_STRATEGY_MESSAGE.PLAN_IS_URL })
    .optional()
    .or(z.literal(''))
    .nullable(),
});

export const GreenhouseStrategySchema = z.object({
  introduction: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateEditorEn, {
        message: GH_STRATEGY_MESSAGE.INTRODUCTION_EN,
      })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, {
        message: GH_STRATEGY_MESSAGE.PLAN_REMARK_EN,
      })
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  plan: GhStrategyPlanSchema,
});
